import React from 'react'
import {Row, Col, InlineLoader} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'

import DynamicEntriesTable, {DynamicEntry} from '../../../../component/dynamic-entries-table'
import SummaryPageFooter from '../../components/summary-page-footer'
import {SECTION_INTERMEDIARY_SHAREHOLDERS} from '../../../../constants/sections'
import {FormContentWrapper} from '../../../../ui/form'
import {StyledImg, ImageContainer} from '../../../summary-page-image/styles'
import {StyledParagraph} from '../../../../ui/styles'
import SummaryPageHeader from '../../components/summary-page-header'

const tableHeadlines = ['name', 'votingSharePercentage']

/** One row of the ShareholderSummaryPage table. */
type ShareholderSummaryEntry = DynamicEntry & {
  route: string
  name: string
  votingSharePercentage?: string
}

export type ShareholderSummaryPageProps = {
  isLoading: boolean
  shareholderSummary: ShareholderSummaryEntry[]
  isReadonly: boolean
  createShareholder: () => void
}

const ShareholderSummaryPage: React.FC<ShareholderSummaryPageProps> = ({
  isLoading,
  shareholderSummary,
  isReadonly,
  createShareholder,
}) => {
  const {t} = useTranslation('charon')

  return (
    <>
      <FormContentWrapper>
        <SummaryPageHeader
          ctaText={t(`sub-section-menu.${SECTION_INTERMEDIARY_SHAREHOLDERS}.create`)}
          onCreate={createShareholder}
          isDisabled={isReadonly}
        />
        {isLoading && (
          <Row>
            <Col>
              <InlineLoader />
            </Col>
          </Row>
        )}
        {!isLoading && shareholderSummary.length < 1 && (
          <>
            <Row justifyContent="center">
              <Col auto>
                <ImageContainer>
                  <StyledImg src="/assets/images/no-results-dynamic-entries.png" alt="no-results" />
                </ImageContainer>
              </Col>
            </Row>
            <Row justifyContent="center">
              <Col auto>
                <StyledParagraph textAlign="center">
                  {t('shareholder-summary-page.no-results.message')}
                </StyledParagraph>
              </Col>
            </Row>
          </>
        )}
        {!isLoading && shareholderSummary.length > 0 && (
          <Row mb={40}>
            <Col>
              <DynamicEntriesTable
                dataList={shareholderSummary || []}
                headlines={tableHeadlines}
                transPrefix="shareholder-summary-page"
              />
            </Col>
          </Row>
        )}
      </FormContentWrapper>
      <SummaryPageFooter sectionName={SECTION_INTERMEDIARY_SHAREHOLDERS} />
    </>
  )
}

export default ShareholderSummaryPage
